/** C94: how a failed query is retried. Once, as before; but a 429 (the server's rate limit, e.g. nginx's on the
 *  dashboard's burst of calls) waits for the server's Retry-After before trying again, else a few seconds with a
 *  little spread so the retries don't arrive together as a second burst. The default (a 1 s wait) retried into the
 *  same limit, so widgets showed "Couldn't load …". */
type HttpError = { response?: { status?: number; headers?: Record<string, unknown> } };

const status = (error: unknown) => (error as HttpError | null)?.response?.status;

export function retryAfterMs(error: unknown): number | null {
  const raw = (error as HttpError | null)?.response?.headers?.['retry-after'];
  if (raw == null || raw === '') return null;
  const secs = Number(raw);
  if (Number.isFinite(secs) && secs >= 0) return Math.min(secs, 30) * 1000;
  const at = Date.parse(String(raw));                     // an HTTP date
  return Number.isNaN(at) ? null : Math.min(Math.max(at - Date.now(), 0), 30_000);
}

export const queryRetry = (failureCount: number, _error: unknown) => failureCount < 1;

export function queryRetryDelay(attempt: number, error: unknown, random: () => number = Math.random): number {
  if (status(error) === 429) return retryAfterMs(error) ?? 2000 + Math.round(random() * 2000);
  return Math.min(1000 * 2 ** attempt, 30_000);
}
